import React, { useState, useRef, useEffect } from 'react';
import constants from '../constants';

const DropDown = ({ list, onSelect, selectedValue, disabled = false }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
  
    const handleChange = (value) => {
      if (disabled) return;
      onSelect(value);
      setIsOpen(false);
    };
  
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
  
      if (isOpen) {
        document.addEventListener('mousedown', handleClickOutside);
      }
  
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [isOpen]);
  
    return (
      <div className="relative w-full" ref={dropdownRef}>
        {isOpen && !disabled && (
          <ul className="absolute z-10 bottom-full mb-1 w-full bg-[#F5F7FB] shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
            {list.map((item, index) => (
              <li
                key={index}
                className="text-gray-900 cursor-default select-none relative py-2 pl-3 pr-9 hover:bg-gray-100"
                onClick={() => handleChange(item)}
              >
                {item.task}
              </li>
            ))}
          </ul>
        )}
        <button
          type="button"
          className={`w-full min-w-[200px] inline-flex justify-between items-center rounded-md px-4 py-2 bg-custom-yellow text-sm font-medium 
            ${disabled 
              ? 'opacity-60 cursor-not-allowed text-white' 
              : 'text-white hover:bg-custom-yellow focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500'
            }`}
          onClick={() => !disabled && setIsOpen(!isOpen)}
          disabled={disabled}
        >
          <img 
            src={constants.tasksIcon} 
            alt="icon" 
            className={disabled ? 'opacity-60' : ''}
          />
          <span className="text-white">{selectedValue || 'Aufgabe auswählen'}</span>
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className={`ml-2 h-3 w-3 transform ${isOpen ? 'rotate-180' : ''} ${disabled ? 'opacity-60' : ''}`} 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
      </div>
    );
  };

export default DropDown;